import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const Divider = styled.div`
  height: ${rem(1)};
  width: 100%;
  border: 1px solid ${({ theme }) => theme.color.beerus[100]};
`;

export default Divider;
